<template>
  <UCard
    :ui="{
      root: 'rounded-xl border-none',
      header: 'bg-primary rounded-t-xl',
    }"
  >
    <template #header>
      <div class="flex items-center justify-between rounded-lg">
        <div class="flex items-center gap-2">
          <Icon :name="icon" class="size-5 text-white" />
          <h3 class="dj-modal-title">
            {{ title }}
          </h3>
        </div>

        <UButton
          variant="ghost"
          size="lg"
          icon="djust-icon:xmark"
          :ui="{ leadingIcon: 'h-4 w-4' }"
          @click="emit('close')"
        />
      </div>
    </template>
    <div class="flex flex-col gap-6">
      <div class="dj-info text-left">
        {{ selectText }}
      </div>
      <USelectMenu
        v-model="selected"
        size="lg"
        trailing-icon="djust-icon:down-select"
        :items="options || []"
        label-key="name"
        searchable
        :placeholder="selectPlaceholder"
        :search-input="{
          placeholder: searchPlaceholder,
        }"
        :ui="{
          base: 'dj-select rounded-xl border-[var(--color-black-650)]',
        }"
        @change="emit('update', selected.id)"
      >
        <template #trailing>
          <UIcon name="djust-icon:down-select" class="w-2 h-2" />
        </template>
        <template #empty>{{ $t('DjAddProductForm.noResults') }}</template>
      </USelectMenu>
      <USeparator label="ou" type="dashed" :ui="{ label: 'font-normal' }" />
      <div class="dj-info text-left">
        {{ createText }}
      </div>
      <UInput
        v-model="name"
        type="text"
        icon="djust-icon:pen"
        size="lg"
        color="white"
        trailing
        :placeholder="inputPlaceholder"
        :disabled="selected"
        required
        :ui="{
          base: 'dj-input h-[42px]',
          trailingIcon: 'size-4',
        }"
      />
      <div class="flex items-center justify-center">
        <UButton
          size="lg"
          icon="i-heroicons-check"
          :label="label"
          class="h-[42px] p-4 text-base font-medium"
          :disabled="isDisabled"
          :ui="{ base: 'disabled:bg-[var(--color-black-350)] disabled:opacity-100' }"
          @click="emit('create', name)"
        />
      </div>
    </div>
  </UCard>
</template>

<script lang="ts" setup>
  defineProps({
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
      default: '',
    },
    selectText: {
      type: String,
      required: true,
    },
    selectPlaceholder: {
      type: String,
      required: false,
      default: '',
    },
    searchPlaceholder: {
      type: String,
      required: false,
      default: '',
    },
    createText: {
      type: String,
      required: true,
    },
    inputPlaceholder: {
      type: String,
      required: false,
      default: '',
    },
    options: {
      type: Array<any>,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
  });
  const emit = defineEmits(['close', 'update', 'create']);
  const name = ref('');
  const selected = ref<any>(null);

  const isDisabled = computed(() => !name.value && !selected.value);
</script>

<style lang="scss" scoped>
  @use './DjAddProductForm.scss';
</style>
